import React from "react";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-container">

        <div className="footer-info">
          <p>
            Milan Building, Rd Number 4,
            Golibar, Santacruz East,<br />
            Mumbai, Maharashtra
          </p>
        </div>

        <div className="footer-info-right">
          <p><strong>Contact:</strong> +91 80974 46666</p>
          <p><strong>Email:</strong> shivanivetkar123@gmail.com</p>
        </div>

        <div className="footer-credit">
          <strong><p>Developed by Yash D.</p></strong>
        </div>

      </div>
    </footer>
  );
};

export default Footer;